import React from 'react';
import { useTranslation } from 'react-i18next';
import { useAnalyticsDispatch } from '../../../analytics/AnalyticsContext';
import { useUdpSectionTracking } from '../../../analytics/use-udp-section-tracking';
import { useSectionMeta } from '../../../components/Section/SectionMetaProvider';
import { Swimlane } from '../../../components/Swimlane/Swimlane';
import { SwimlaneTitle } from '../../../components/Swimlane/SwimlaneTitle';
import { Swipeable } from '../../../components/Swipeable/Swipeable';
import { AspectPlaceholder } from '../../../components/Teaser/Placeholder/AspectPlaceholder';
import { TopicTeaser } from '../../../components/Teaser/TopicTeaser/TopicTeaser';
import { useTopicState } from '../../../providers/DataProvider/DataContext';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const swipeableConfig = [['small', {
  itemCount: 2.3,
  spaceBefore: 16,
  spaceBetween: 8
}], ['medium', {
  itemCount: 4.1,
  spaceBefore: 24,
  spaceBetween: 16
}], ['large', {
  itemCount: 5.3,
  spaceBefore: 32,
  spaceBetween: 16
}], ['xLargeUp', {
  itemCount: 6.3,
  spaceBefore: 0,
  spaceBetween: 16
}]];
export const TopicSelector = () => {
  const {
    t
  } = useTranslation();
  const {
    userTopics,
    isTopicsLoading
  } = useTopicState();
  const sectionMeta = useSectionMeta();
  const analyticsDispatch = useAnalyticsDispatch();
  const trackSection = useUdpSectionTracking();
  const showSwimlane = userTopics.length > 0 || isTopicsLoading;
  return /*#__PURE__*/_jsxs(Swimlane, {
    children: [/*#__PURE__*/_jsx(SwimlaneTitle, {
      title: t('global.topics')
    }), showSwimlane && /*#__PURE__*/_jsx(Swipeable, {
      config: swipeableConfig,
      placeholder: /*#__PURE__*/_jsx(AspectPlaceholder, {
        aspectRatio: 16 / 9
      }),
      analyticsTitle: "TopicSelector",
      children: userTopics.map((topic, index) => /*#__PURE__*/_jsx(TopicTeaser, {
        topic: topic,
        onClick: () => {
          analyticsDispatch({
            type: 'click-event',
            name: 'TopicSelectorClick',
            value1: topic.id,
            value2: sectionMeta.sectionId,
            value3: topic.title
          });
          if (sectionMeta.representationName) {
            trackSection({
              sectionMeta,
              item: {
                ...topic,
                index
              }
            });
          }
        }
      }, topic.id))
    })]
  });
};